import gql from "graphql-tag";

export const fragmentAddress = gql`
  fragment AddressFragment on Address {
    city
    cityArea
    companyName
    country {
      __typename
      code
      country
      regions {
        code
        region: name
      }
    }
    email
    countryArea
    firstName
    id
    lastName
    phone
    postalCode
    streetAddress1
    streetAddress2
    taxNumber
  }
`;
